import { useParams, useSearchParams, Link } from 'react-router-dom';

export default function InvoiceThankYouPage() {
  useParams();
  const [params] = useSearchParams();
  const tip = parseFloat(params.get('tip') || '0');

  return (
    <div style={{ minHeight: '100vh', background: '#0a0a0a', fontFamily: "'Helvetica Neue', Arial, sans-serif" }}>

      {/* Header */}
      <div style={{ background: '#000', borderBottom: '1px solid #1a1a1a', padding: '28px 20px', textAlign: 'center' }}>
        <img
          src="/images/logo.png"
          alt="Monarch Detailing"
          style={{ height: 64, width: 'auto', objectFit: 'contain', marginBottom: 12, display: 'block', marginLeft: 'auto', marginRight: 'auto' }}
          onError={e => { e.target.style.display = 'none'; }}
        />
        <p style={{ color: '#68caf1', fontSize: 11, letterSpacing: 4, textTransform: 'uppercase', margin: '0 0 4px' }}>Monarch Detailing</p>
        <p style={{ color: '#333', fontSize: 10, letterSpacing: 3, textTransform: 'uppercase', margin: 0 }}>Automotive Alchemy</p>
      </div>

      <div style={{ maxWidth: 520, margin: '0 auto', padding: '60px 20px 80px', textAlign: 'center' }}>

        {/* Checkmark */}
        <div style={{ width: 72, height: 72, borderRadius: '50%', background: '#4ade8020', border: '2px solid #4ade80', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 28px', fontSize: 32 }}>
          ✓
        </div>

        <p style={{ color: '#4ade80', fontSize: 12, letterSpacing: 3, textTransform: 'uppercase', margin: '0 0 12px' }}>Payment Received</p>
        <h1 style={{ color: '#fff', fontSize: 30, fontWeight: 700, margin: '0 0 16px', lineHeight: 1.2 }}>
          Thank you for your payment.
        </h1>
        <p style={{ color: '#aaa', fontSize: 15, lineHeight: 1.7, margin: '0 0 32px' }}>
          Your payment has been confirmed. Akeem appreciates you trusting Monarch Detailing with your vehicle.
        </p>

        {tip > 0 && (
          <div style={{ background: '#0f0f0f', border: '1px solid #4ade8033', borderRadius: 12, padding: '20px 24px', marginBottom: 32 }}>
            <p style={{ color: '#4ade80', fontSize: 11, letterSpacing: 3, textTransform: 'uppercase', margin: '0 0 8px' }}>Gratuity</p>
            <p style={{ color: '#fff', fontSize: 18, fontWeight: 700, margin: '0 0 6px' }}>
              Including your ${tip.toFixed(2)} tip
            </p>
            <p style={{ color: '#555', fontSize: 13, margin: 0 }}>
              Akeem receives 100% of this gratuity. It means the world.
            </p>
          </div>
        )}

        {/* Google Review CTA */}
        <div style={{ background: '#111', border: '1px solid #1a1a1a', borderRadius: 12, padding: '28px 24px', marginBottom: 32 }}>
          <p style={{ color: '#68caf1', fontSize: 10, letterSpacing: 3, textTransform: 'uppercase', margin: '0 0 10px' }}>One more thing</p>
          <p style={{ color: '#aaa', fontSize: 14, lineHeight: 1.7, margin: '0 0 20px' }}>
            A Google review helps Akeem grow Monarch Detailing and helps other car owners find us. If you loved the service, 30 seconds makes a real difference.
          </p>
          <a
            href="https://g.page/r/CXdr5n1W7IbjEBM/review"
            target="_blank"
            rel="noopener noreferrer"
            style={{ display: 'inline-block', background: '#68caf1', color: '#000', fontWeight: 700, fontSize: 14, padding: '13px 28px', borderRadius: 8, textDecoration: 'none', letterSpacing: 0.3 }}
          >
            ⭐ Leave a Google Review
          </a>
        </div>

        {/* Quote */}
        <div style={{ borderTop: '1px solid #1a1a1a', paddingTop: 28 }}>
          <p style={{ color: '#555', fontSize: 14, fontStyle: 'italic', lineHeight: 1.8, margin: '0 0 10px' }}>
            "Every vehicle I touch gets my full attention. It was a pleasure — see you next time."
          </p>
          <p style={{ color: '#68caf1', fontSize: 13, fontWeight: 600, margin: 0 }}>— Akeem James, Founder</p>
        </div>

        <div style={{ marginTop: 40 }}>
          <Link
            to="/"
            style={{ color: '#333', fontSize: 13, textDecoration: 'none', letterSpacing: 1 }}
          >
            ← Back to monarchdetailing.art
          </Link>
        </div>
      </div>
    </div>
  );
}
